import { useSearchParams } from "next/navigation";

import type { BuilderModels } from "../builder.models.types";
import { BUILDER_FRAME_EDITING_SEARCH_PARAM } from "../consts";

// Hook to check if the current model is being edited in the Builder.io editor
export function useIsEditingModel(model: BuilderModels) {
  const searchParams = useSearchParams();
  const frameEditingModelName = searchParams.get(BUILDER_FRAME_EDITING_SEARCH_PARAM);

  return frameEditingModelName === model;
}
